import { useEffect, useState } from 'react';
import './index.css';

export default function ScrollProgress() {
    const [pct, setPct] = useState(0);
    useEffect(() => {
        const onScroll = () => {
            const h = document.documentElement;
            const total = h.scrollHeight - h.clientHeight;
            setPct(total > 0 ? (h.scrollTop / total) * 100 : 0);
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    return (
        <div className="scroll-progress" aria-hidden>
            <div className="scroll-progress-bar" style={{ width: `${pct}%` }} />
        </div>
    );
}
